/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApiKey } from '../models/ApiKey';
import type { ApiKeyCreateRequest } from '../models/ApiKeyCreateRequest';
import type { ApiKeyCreateResponse } from '../models/ApiKeyCreateResponse';
import type { ApiKeyMtlsCertificate } from '../models/ApiKeyMtlsCertificate';
import type { ApiKeyMtlsCertificateCreateRequest } from '../models/ApiKeyMtlsCertificateCreateRequest';
import type { ApiKeyMtlsCertificateUpdateRequest } from '../models/ApiKeyMtlsCertificateUpdateRequest';
import type { ApiKeyUpdateRequest } from '../models/ApiKeyUpdateRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ApiKeysService {
    /**
     * Creates a new API key for a client
     * @returns ApiKeyCreateResponse Successful operation.
     * @throws ApiError
     */
    public static createApiKey({
        requestBody,
    }: {
        requestBody?: ApiKeyCreateRequest,
    }): CancelablePromise<ApiKeyCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/apiKeys',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Lists all API keys across all clients, with optional filtering by client ID
     * @returns any Successful operation.
     * @throws ApiError
     */
    public static listApiKeys({
        clientId,
        limit = 20,
        nextToken,
    }: {
        /**
         * Optional client ID to filter API keys
         */
        clientId?: string,
        /**
         * Maximum number of items to return
         */
        limit?: number,
        /**
         * Token for pagination
         */
        nextToken?: string,
    }): CancelablePromise<{
        items?: Array<ApiKey>;
        nextToken?: string;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/apiKeys',
            query: {
                'clientId': clientId,
                'limit': limit,
                'nextToken': nextToken,
            },
        });
    }
    /**
     * Gets details for a specific API key
     * @returns ApiKey Successful operation.
     * @throws ApiError
     */
    public static getApiKey({
        keyId,
    }: {
        /**
         * API Key ID
         */
        keyId: string,
    }): CancelablePromise<ApiKey> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/apiKeys/{keyId}',
            path: {
                'keyId': keyId,
            },
        });
    }
    /**
     * Updates an existing API key
     * @returns ApiKey Successful operation.
     * @throws ApiError
     */
    public static updateApiKey({
        keyId,
        requestBody,
    }: {
        /**
         * API Key ID
         */
        keyId: string,
        requestBody?: ApiKeyUpdateRequest,
    }): CancelablePromise<ApiKey> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/apiKeys/{keyId}',
            path: {
                'keyId': keyId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Deletes an API key
     * @returns any Successful operation.
     * @throws ApiError
     */
    public static deleteApiKey({
        keyId,
    }: {
        /**
         * API Key ID
         */
        keyId: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/apiKeys/{keyId}',
            path: {
                'keyId': keyId,
            },
        });
    }
    /**
     * Adds an mTLS client certificate binding to an API key
     * @returns ApiKeyMtlsCertificate Successful operation.
     * @throws ApiError
     */
    public static addApiKeyMtlsCertificate({
        keyId,
        requestBody,
    }: {
        /**
         * API Key ID
         */
        keyId: string,
        requestBody?: ApiKeyMtlsCertificateCreateRequest,
    }): CancelablePromise<ApiKeyMtlsCertificate> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/apiKeys/{keyId}/mtls/certificates',
            path: {
                'keyId': keyId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Updates an mTLS client certificate binding for an API key
     * @returns ApiKeyMtlsCertificate Successful operation.
     * @throws ApiError
     */
    public static updateApiKeyMtlsCertificate({
        keyId,
        certificateId,
        requestBody,
    }: {
        /**
         * API Key ID
         */
        keyId: string,
        /**
         * Certificate binding ID
         */
        certificateId: string,
        requestBody?: ApiKeyMtlsCertificateUpdateRequest,
    }): CancelablePromise<ApiKeyMtlsCertificate> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/apiKeys/{keyId}/mtls/certificates/{certificateId}',
            path: {
                'keyId': keyId,
                'certificateId': certificateId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Deletes an mTLS client certificate binding from an API key
     * @returns any Successful operation.
     * @throws ApiError
     */
    public static deleteApiKeyMtlsCertificate({
        keyId,
        certificateId,
    }: {
        /**
         * API Key ID
         */
        keyId: string,
        /**
         * Certificate binding ID
         */
        certificateId: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/apiKeys/{keyId}/mtls/certificates/{certificateId}',
            path: {
                'keyId': keyId,
                'certificateId': certificateId,
            },
        });
    }
}
